import { ElementRef, Directive, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[matTooltip][appShowIfTruncated]',
    standalone: false
})
export class ShowIfTruncatedDirective {
    constructor(
        private matTooltip: MatTooltip,
        private elementRef: ElementRef<HTMLElement>
    ) { }

    @HostListener('mouseenter')
    setTooltipState() {
        const element = this.elementRef.nativeElement;
        this.matTooltip.disabled = element.scrollWidth <= element.clientWidth &&
            element.scrollHeight <= element.clientHeight;
    }
}
